import { useState, useEffect } from 'react';
import GridComponent from '../../../../component/grid/GridComponent.component';
import { useFormik } from 'formik';
import FormLabel from '../../../../component/input/FormLabel.component';
import Group from '../interfaces/Group';
import Grid from '@material-ui/core/Grid';
import Button from '../../../../component/buttton/Button.component';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { FormInput } from '../../../../component/input/InputStyle';
import { useSnackbar } from '../../../../context/Snackbar';
import { getGroupsLocal } from '../Groups.service';
import { FormInterface } from '../../../../core/interfaces/form/Form';

export default function Form({ handleSubmitForm, initialValues }: FormInterface<Group>) {

    const { setSnackbar } = useSnackbar();
    const [groups, setGroups] = useState<Group[]>([]);
    const [groupName, setGroupName] = useState<string>('');
    useEffect(() => {
        getGroupsLocal().then(res => {
            setGroups(res.data);
        }).catch((error) => {
            console.log('Erro ao consultar grupos!', error);
            setSnackbar({ msg: "Erro ao consultar grupos!", type: 'error' });
        })
    }, [setSnackbar]);

    const filterName = (name: string, grupoList: Group[]): string | undefined => {
        let gruopAux: Group | undefined = grupoList.find((grupo: Group) => grupo.Nome.toUpperCase().includes(name.toUpperCase()));
        return gruopAux?.Id;
    }

    const { handleSubmit, setFieldValue } = useFormik<Group>({
        initialValues: initialValues,
        onSubmit: values => {
            if (!values.Id) {
                values.Id = filterName(groupName, [...groups]);
            }
            handleSubmitForm(values);
        },
    });

    return (
        <form onSubmit={handleSubmit}>
            <GridComponent justify="flex-start" alignItems="flex-end" spacing={2} >
                <FormLabel title="Selecione o Grupo Local" sm={9} md={10} >
                    <Autocomplete
                        id='combo-box-gupos'
                        size='small'
                        options={groups}
                        getOptionLabel={(option: Group) => option.Nome}
                        freeSolo
                        onChange={(_event: React.ChangeEvent<any>, group: Group | any) => {
                            setFieldValue('Id', group?.Id);
                        }}
                        renderInput={(params: any) => (
                            <FormInput onChange={() => setGroupName(params.inputProps.value)} {...params} />
                        )}
                    />

                </FormLabel>
                <Grid item sm={3} md={2}>
                    <Button title="Pesquisar" size='medium' />
                </Grid>
            </GridComponent>
        </form>
    )
}
